// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewMerchantGroups_container__1jgco","tableWrapper":"ViewMerchantGroups_tableWrapper__1QKgd"};